import * as core from '../../../../../../../core'

import { query } from './space-table-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.space-table',
    description: 'Displays a list of spaces in a table widget',
    name: 'RP Explore - Space Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
